export default "__VITE_ASSET__xsIDLa$f__"